import { selectCurrUser } from '@/store/bootstrap/selectors';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useSafeSelector } from './use-safe-selector';

// Developers can override flags here and test them in development
const devOverrideFlags = {
  feReq: true,
  feNewPdfViewer: true,
  feCertn: true,
  feZinc: true,
  fePublicApiApplication: true,
  feOverrideType: true,
  feDownloadScorecard: true,
  feTransferCandidateSc: true,
  feScorecardThreshold: true,
  // agents
  feJobTeammates: true,
  feCoordinatorAgent: true,
  feFraudDetection: true,
  // candidate availability
  feCandidateAvailability: true,
  feAgentForce: true,
  feScorecardOptional: true,
  feSchedulingRevampV2: true,
  feRemoteInterview: true,
  feNotificationCenter: true,
  feInterviewBuffer: true,
  feManualInterviewBuffer: true,
  feScheduleAllV2: true,
  feJobDescriptionTemplates: true,
  feKanbanPragmaticDnd: true,
  feDarwinbox: true,
};

export const useKFlags = () => {
  const flags = useFlags();

  // Wrap the selector in useSafeSelector to prevent errors for non redux app like assessment or signup and assign default value for currUser
  const currUser = useSafeSelector(selectCurrUser) || {
    feature_options: {
      ats_enabled: false,
      circles_enabled: false,
      outreach_enabled: false,
    },
  };

  return {
    ...flags,
    ...currUser?.feature_options,
    ...(import.meta.env.VITE_ENV === 'development' ? devOverrideFlags : {}),
  };
};
